export default __webpack_public_path__ + "static/media/029-fence.f3e932d5.svg";